var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeBannerModalbullet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48769 14.7365C10.0707 14.7365 12.9754 11.9444 12.9754 8.50005C12.9754 5.05573 10.0707 2.26355 6.48769 2.26355C2.90464 2.26355 0 5.05573 0 8.50005C0 11.9444 2.90464 14.7365 6.48769 14.7365Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0727 -0.00634766C12.5568 0.227917 13.0146 0.487508 13.4658 0.756596C13.9169 1.02568 14.3549 1.30427 14.7831 1.58602C15.6459 2.15796 16.4824 2.75523 17.2925 3.37782C18.9027 4.62131 20.4418 5.94758 21.903 7.35082L22.9964 8.39235L21.8997 9.45287C21.1555 10.1715 20.398 10.8743 19.6142 11.5549C18.8304 12.2355 18.0302 12.8972 17.2036 13.5335C16.377 14.1698 15.524 14.7998 14.6447 15.3728C14.2001 15.664 13.7523 15.949 13.2912 16.2212C12.8301 16.4935 12.3625 16.7626 11.8652 17C12.1155 16.5251 12.3922 16.0724 12.6787 15.6324C12.9652 15.1923 13.2583 14.7586 13.5613 14.3313C14.1716 13.4871 14.8094 12.6671 15.4746 11.8715C16.1333 11.0769 16.8249 10.3076 17.5329 9.55418C18.2409 8.80073 18.9721 8.06945 19.7196 7.35716V9.45287C18.2599 8.04821 16.8802 6.56871 15.5866 5.02084C14.9411 4.24207 14.3198 3.43798 13.7226 2.60855C13.4295 2.19384 13.1364 1.7728 12.8598 1.34226C12.5832 0.911719 12.3164 0.465347 12.0727 -0.00634766Z",
    fill: "url(#paint0_linear_1_1964)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0727 -0.00634766C12.5568 0.227917 13.0146 0.487508 13.4658 0.756596C13.9169 1.02568 14.3549 1.30427 14.7831 1.58602C15.6459 2.15796 16.4824 2.75523 17.2925 3.37782C18.9027 4.62131 20.4418 5.94758 21.903 7.35082L22.9964 8.39235L21.8997 9.45287C21.1555 10.1715 20.398 10.8743 19.6142 11.5549C18.8304 12.2355 18.0302 12.8972 17.2036 13.5335C16.377 14.1698 15.524 14.7998 14.6447 15.3728C14.2001 15.664 13.7523 15.949 13.2912 16.2212C12.8301 16.4935 12.3625 16.7626 11.8652 17C12.1155 16.5251 12.3922 16.0724 12.6787 15.6324C12.9652 15.1923 13.2583 14.7586 13.5613 14.3313C14.1716 13.4871 14.8094 12.6671 15.4746 11.8715C16.1333 11.0769 16.8249 10.3076 17.5329 9.55418C18.2409 8.80073 18.9721 8.06945 19.7196 7.35716V9.45287C18.2599 8.04821 16.8802 6.56871 15.5866 5.02084C14.9411 4.24207 14.3198 3.43798 13.7226 2.60855C13.4295 2.19384 13.1364 1.7728 12.8598 1.34226C12.5832 0.911719 12.3164 0.465347 12.0727 -0.00634766Z",
    fill: "#004080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1964",
    x1: 11.8718,
    y1: 8.49998,
    x2: 22.9997,
    y2: 8.49998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE023D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerModalbullet);
export default __webpack_public_path__ + "static/media/homeBannerModalbullet.3ccc2d68efbab76722d6763ef2d69b7f.svg";
export { ForwardRef as ReactComponent };